import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import {addGlobalError} from "../../../../actions/globalerror";
import config from "../../../../../../server/src/config";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class Watches extends React.Component {
    static propTypes = {
        data: PropTypes.array.isRequired,
        setEditMode: PropTypes.func.isRequired,
        updateRow: PropTypes.func.isRequired,
        deleteRow: PropTypes.func.isRequired,
        acceptRow: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            editIx: null,
        };
    }

    fields = [];
    render() {
        return <div>
            <table className="data-table">
                <thead>
                <tr>
                    <th></th>
                    <th>Fejltekst</th>
                    <th className="center">Uge</th>
                    <th className="center">Foren</th>
                    <th className="center">Slag</th>
                    <th className="center">Ur</th>
                    <th>Startdato</th>
                    <th>Starttid</th>
                    <th>Kontroldato</th>
                    <th>Kontroltid</th>
                    <th>Udviser</th>
                    <th>Vers.</th>
                </tr>
                </thead>
                <tbody>
                {this.props.data.map((row, ix) => ix === this.state.editIx ? <tr key={ix} className="edit-row">
                    <th scope="row" style={{minWidth: '80px'}}>
                        <i className="fa fa-save clickable" title="Gem station" onClick={() => {
                            if (this.allInputValid()) {
                                this.props.updateRow({
                                    Foreningsnr: row.Foreningsnr,
                                    Slagnr: row.Slagnr,
                                    Ugenr: row.Ugenr,
                                    Urnr: row.Urnr,
                                }, {
                                    Ugenr: this.state.Ugenr === '' ? null : this.state.Ugenr,
                                    Foreningsnr: this.state.Foreningsnr === '' ? null : this.state.Foreningsnr,
                                    Slagnr: this.state.Slagnr === '' ? null : this.state.Slagnr,
                                    Urnr: this.state.Urnr === '' ? null : Number(this.state.Urnr),
                                    Startdato: this.state.Startdato === '' ? null : moment(this.state.Startdato, config.formats.dateFormat).format('YYYY-MM-DD'),
                                    Starttid: this.state.Starttid === '' ? null : this.state.Starttid,
                                    Kontroldato: this.state.Kontroldato === '' ? null : moment(this.state.Kontroldato, config.formats.dateFormat).format('YYYY-MM-DD'),
                                    Kontroltid: this.state.Kontroltid === '' ? null : this.state.Kontroltid,
                                    Udvisen: this.state.Udvisen === '' ? null : this.state.Udvisen,
                                }, () => {
                                    NotificationManager.success("Urnummer " + String(this.state.Urnr) + " for slag " + this.state.Slagnr + " i forening " + this.state.Foreningsnr + " er opdateret.", "Opdatering", 4000);
                                    this.setState({editIx: null});
                                    this.props.setEditMode(false);
                                });
                            } else {
                                this.fields.forEach((field) => {
                                    field.setState({visited: true});
                                });
                            }
                        }}/>
                        <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                            this.setState({editIx: null});
                            this.props.setEditMode(false);
                        }}/>
                    </th>
                    <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Ugenr" id="Ugenr" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,2}"}]} value={this.state.Ugenr}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[0] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Foreningsnr" id="Foreningsnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Foreningsnr}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[1] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Slagnr" id="Slagnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Slagnr}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[2] = instance; }}
                        />
                    </td>
                    <td className="center">
                        <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                          name="Urnr" id="Urnr" value={this.state.Urnr}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[3] = instance; }}
                        />
                    </td>
                    <td>
                        <UserFieldElement dataType={UserFieldDataType.date} placeholder="" className="field125"
                                          name="Startdato" id="Startdato" maxLength="10" value={this.state.Startdato}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[4] = instance; }}
                        />
                    </td>
                    <td>
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                          name="Starttid" id="Starttid" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}\\:[0-9]{2}\\:[0-9]{2}"}]} value={this.state.Starttid}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[5] = instance; }}
                        />
                    </td>
                    <td>
                        <UserFieldElement dataType={UserFieldDataType.date} placeholder="" className="field125" containerClassName="display-inline-block"
                                          name="Kontroldato" id="Kontroldato" maxLength="10" value={this.state.Kontroldato}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[6] = instance; }}
                        />
                    </td>
                    <td>
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                          name="Kontroltid" id="Kontroltid" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}\\:[0-9]{2}\\:[0-9]{2}"}]} value={this.state.Kontroltid}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[7] = instance; }}
                        />
                    </td>
                    <td>
                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                          name="Udvisen" id="Udvisen" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}\\:[0-9]{2}\\:[0-9]{2}"}]} value={this.state.Udvisen}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[8] = instance; }}
                        />
                    </td>
                    <td>{row.Programversion === null ? '' : row.Programversion}</td>
                </tr> : <tr key={ix}>
                    <th scope="row" style={{minWidth: '80px'}}>
                        <i className={"fa fa-pencil " + (this.state.editIx === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                            if (this.state.editIx === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) {
                                this.setState({
                                    Ugenr: row.Ugenr === null ? '' : row.Ugenr,
                                    Foreningsnr: row.Foreningsnr === null ? '' : row.Foreningsnr,
                                    Slagnr: row.Slagnr === null ? '' : row.Slagnr,
                                    Ringnummer: row.Ringnummer === null ? '' : row.Ringnummer,
                                    Urnr: row.Urnr === null ? '' : String(row.Urnr),
                                    Startdato: row.Startdato === null ? '' : moment(row.Startdato).format(config.formats.dateFormat),
                                    Starttid: row.Starttid === null ? '' : row.Starttid,
                                    Kontroldato: row.Kontroldato === null ? '' : moment(row.Kontroldato).format(config.formats.dateFormat),
                                    Kontroltid: row.Kontroltid === null ? '' : row.Kontroltid,
                                    Udvisen: row.Udvisen === null ? '' : row.Udvisen,
                                    editIx: ix,
                                });
                                this.props.setEditMode(true);
                            }
                        }}/>
                        <i className={"fa fa-trash " + (this.state.editIx === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? 'clickable' : 'disabled')} title="Slet række" onClick={() => {
                            if (this.state.editIx === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) confirm("Slet", <span>Ønsker du at slette urnummer <b>{row.Urnr}</b> for slag <b>{row.Slagnr}</b> i forening <b>{row.Foreningsnr}</b>?</span>, () => {
                                this.props.deleteRow([{
                                    Foreningsnr: row.Foreningsnr,
                                    Slagnr: row.Slagnr,
                                    Ugenr: row.Ugenr,
                                    Urnr: row.Urnr,
                                }], () => {
                                    NotificationManager.success("Urnummer " + String(row.Urnr) + " for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " er slettet.", "Sletning", 4000);
                                });
                            });
                        }}/>
                        <i className={"fa fa-check " + (this.state.editIx === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? 'clickable' : 'disabled')} title="Accepter række" onClick={() => {
                            if (this.state.editIx === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) confirm("Accepter", <span>Ønsker du at acceptere urnummer <b>{row.Urnr}</b> for slag <b>{row.Slagnr}</b> i forening <b>{row.Foreningsnr}</b>?</span>, () => {
                                this.props.acceptRow([{
                                    Foreningsnr: row.Foreningsnr,
                                    Slagnr: row.Slagnr,
                                    Ugenr: row.Ugenr,
                                    Urnr: row.Urnr,
                                }], (response) => {
                                    if (response.failed.length > 0) this.props.dispatch(addGlobalError('Fejl ved accept', response.failed[0].msg, -1));
                                    else NotificationManager.success("Urnummer " + String(row.Urnr) + " for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " er accepteret.", "Accept", 4000);
                                });
                            });
                        }}/>
                    </th>
                    <td>{row.Fejltekst === null ? '' : row.Fejltekst}</td>
                    <td className="center">{row.Ugenr === null ? '' : row.Ugenr}</td>
                    <td className="center">{row.Foreningsnr === null ? '' : row.Foreningsnr}</td>
                    <td className="center">{row.Slagnr === null ? '' : row.Slagnr}</td>
                    <td className="center">{row.Urnr === null ? '' : String(row.Urnr)}</td>
                    <td>{row.Startdato === null ? '' : moment(row.Startdato).format(config.formats.dateFormat)}</td>
                    <td>{row.Starttid === null ? '' : row.Starttid}</td>
                    <td>{row.Kontroldato === null ? '' : moment(row.Kontroldato).format(config.formats.dateFormat)}</td>
                    <td>{row.Kontroltid === null ? '' : row.Kontroltid}</td>
                    <td>{row.Udvisen === null ? '' : row.Udvisen}</td>
                    <td>{row.Programversion === null ? '' : row.Programversion}</td>
                </tr>)}
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getAllKeys = () => {
        return this.props.data.map(row => ({
            Foreningsnr: row.Foreningsnr,
            Slagnr: row.Slagnr,
            Ugenr: row.Ugenr,
            Urnr: row.Urnr,
        }));
    };
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(Watches);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/errorLists/subPages/Watches.js